// S4 All tickets (CT-001): the queue across every app (every Editor and Admin sees them all, poc CT-008),
// with an App column and an App filter; search covers them all. Staff land here from "/".
import { createFileRoute } from '@tanstack/react-router';
import { QueueView } from '@/features/tickets/QueueView';
import { parseQueueSearch, type QueueSearch } from '@/features/tickets/queue-search';
import { requireStaffSession } from '@/lib/session';

export const Route = createFileRoute('/queue')({
  validateSearch: parseQueueSearch,
  beforeLoad: ({ context, location }) => requireStaffSession(context.queryClient, location.href),
  component: AllTicketsPage,
});

function AllTicketsPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <QueueView
      appId={null}
      search={search}
      setSearch={(patch) =>
        navigate({ search: (prev: QueueSearch) => ({ ...prev, ...patch, page: undefined }), replace: true })
      }
      onPageChange={(page) => navigate({ search: (prev: QueueSearch) => ({ ...prev, page }) })}
    />
  );
}
